// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ea5L","actions":"styles_actions__3rnze","error":"styles_error__1asKf","message":"styles_message__1LxRD"};